import { CheckIcon, DoubleArrowIcon } from "../../../../../assets/icons";

export const ContractReadyCard = ({ title, description, onView }) => (
  <button
    type="button"
    aria-label={`View contract: ${title || "Contract ready"}`}
    onClick={() => {
      onView?.();
    }}
    className="w-full max-w-sm lg:max-w-md rounded-xl border border-success/20 bg-success/10 p-4 text-left shadow-sm transition hover:border-success/30 hover:bg-success/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-success/60 cursor-pointer"
  >
    <div className="flex items-start gap-3">
      <span
        aria-hidden="true"
        className="mt-0.5 inline-flex h-8 w-8 items-center justify-center rounded-full bg-success/20 text-success"
      >
        <CheckIcon width={16} height={16} />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-success truncate">
          {title || "Contract ready"}
        </p>
        <p className="mt-1 text-xs text-success/80 text-pretty line-clamp-2">
          {description || "View your generated contract."}
        </p>
        <span className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-success">
          View Contract
          <DoubleArrowIcon
            width={12}
            height={12}
            className="text-success"
          />
        </span>
      </div>
    </div>
  </button>
);
